import { render, staticRenderFns } from "./SuccessfulBiddersPagination.vue?vue&type=template&id=4acb7079&"
import script from "./SuccessfulBiddersPagination.vue?vue&type=script&lang=js&"
export * from "./SuccessfulBiddersPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4acb7079')) {
      api.createRecord('4acb7079', component.options)
    } else {
      api.reload('4acb7079', component.options)
    }
    module.hot.accept("./SuccessfulBiddersPagination.vue?vue&type=template&id=4acb7079&", function () {
      api.rerender('4acb7079', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/successfulBidder/views/components/SuccessfulBiddersPagination.vue"
export default component.exports